import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { UploadFilesButton } from "nlib/ui";
import { checkSelectedBusinessRpaMode } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import AdvancedTransactionTypes from "const/AdvancedTransactionTypes";
import AttachedDocumentActions from "nlib/common/AttachedDocumentActions";
import DataStatuses from "const/DataStatuses";
import DocumentPreview from "nlib/common/DocumentPreview";
import DocumentRecogniseStatuses from "const/DocumentRecogniseStatuses";
import Preloader from "nlib/common/Preloader";
import React, { useCallback, useState } from "react";
import classNames from "classnames";
import useAttachDocument from "hooks/useAttachDocument";

const Document = (props) => {
  const {
    disabled,
    className,
    advancedType,
    transaction,
    onDocumentAttach,
    onDocumentEdit
  } = props;

  const {
    id: transactionId,
    type,
    status,
    usesItems,
    documentId,
    documentPreview,
    documentAttachment = {},
    documentRecogniseStatus
  } = transaction;

  const { uiTexts } = useSelector(getTextsData);

  const attachDocument = useAttachDocument({ id: transactionId, documentId, type });

  const rpaMode = useSelector(checkSelectedBusinessRpaMode);

  const [fetching, setFetching] = useState(false);

  const disabledInput = status === DataStatuses.TO_REVIEW
    || advancedType === AdvancedTransactionTypes.TRANSFER
    || (rpaMode && advancedType !== AdvancedTransactionTypes.BANK_FEED);

  const handleFileChange = useCallback(async([file]) => {
    if (file) {
      setFetching(true);

      const attachResult = await attachDocument(file);

      if (attachResult && onDocumentAttach) {
        onDocumentAttach(transaction.id, attachResult.id);
      }
      setFetching(false);
    }
  }, [
    transaction,
    onDocumentAttach,
    attachDocument
  ]);

  if (usesItems) return null;

  return (
    <div className={classNames(Css.document, className)}>
      {documentId
        ? (
          <>
            <DocumentPreview
              className={Css.preview}
              error={documentRecogniseStatus === DocumentRecogniseStatuses.ERROR}
              transactionId={transactionId}
              hasAttachment={!!documentAttachment.key}
              documentPreview={documentPreview} />
            <AttachedDocumentActions
              className={Css.attachedDocumentActions}
              disabled={disabled}
              transaction={transaction}
              onEdit={onDocumentEdit} />
          </>
        )
        : (
          <UploadFilesButton
            outline
            loading={fetching}
            disabled={disabled || disabledInput}
            title={(!disabledInput && !documentId) ? uiTexts.provideDocument : ""}
            className={Css.attachment}
            onChange={handleFileChange}>
            <div className={Css.content}>
              {fetching ? <Preloader className={Css.preloader} /> : <Icons.FilePlus />}
              <span>
                {fetching ? `${uiTexts.uploading}...` : uiTexts.provideDocument}
              </span>
            </div>
          </UploadFilesButton>
        )}
    </div>
  );
};

export default React.memo(Document);
